import { useCallback, useContext, useEffect, useState } from "react"
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import numeral from 'numeral'
import { faHandBackFist, faTruckFast } from "@fortawesome/free-solid-svg-icons"
import { Table, Tag } from 'antd'

import { ApplicationContext } from 'context'

import ButtonPrimary from "components/ButtonPrimary"
// import SearchBar from "components/SearchBar"
import PowerPackTransfer from "components/PowerPackTransfer"

import api from 'lib/api'
import { discectError } from "lib/utils"

import styles from "./styles.module.scss"
// import InputWrapper from "components/InputWrapper"

dayjs.extend(utc)

const InventoryPowerPacks = (props) => {
  const { contextAgency, contextError, contextLoading } = useContext(ApplicationContext)
  const [isLoading, setIsLoading] = contextLoading // eslint-disable-line
  const [_, setError] = contextError // eslint-disable-line
  const [agency] = contextAgency // eslint-disable-line

  // const [search, setSearch] = useState(null)
  const [transferClaim, setTransferClaim] = useState(null)
  const [transfers, setTransfers] = useState(null)
  const [packages, setPackages] = useState(null)

  const agencyId = agency.id

  const _fetchPackages = useCallback(async () => {
    setIsLoading(true)
    try {
      const { packages: incomingPackages } = await api.inventory.fetchPackages(agencyId)
      setPackages(incomingPackages.sort((a, b) => (a.created_at < b.created_at) ? 1 : -1))
      const { transfers: incomingTransfers } = await api.inventory.fetchTransfers(agencyId)
      setTransfers(incomingTransfers)
    } catch(e) {
      setError(discectError(e))
    }
    setIsLoading(false)

  }, [setError, setIsLoading, agencyId])

  useEffect(() => {
    if (!packages) _fetchPackages()
  }, [packages, _fetchPackages])
  
  const _getTable = (data) => {
    const columns = [
      {
        title: 'ID',
        dataIndex: 'dbId',
        key: 'dbId',
        width: 40,
        render: (_, { dbId }) => {
          return (
            <div className={styles.agencyInfo}>
              <p>{dbId}</p>
            </div>
          )
        }
      },
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        render: (_, { name }) => {
          return (
            <div className={styles.agencyInfo}>
              <p>{name}</p>
            </div>
          )
        }
      },
      {
        title: 'Total Powers',
        dataIndex: 'total',
        key: 'total',
        width: 140,
        align: 'center',
        render: (_, { totalPowers }) => {
          return (
            <div className={styles.agencyInfo}>
              <p>{totalPowers}</p>
            </div>
          )
        }
      },
      {
        title: 'Total Liability',
        dataIndex: 'total',
        key: 'total',
        width: 140,
        align: 'center',
        render: (_, { total }) => {
          return (
            <div className={styles.agencyInfo}>
              <p>{total}</p>
            </div>
          )
        }
      },
      {
        title: 'Status',
        key: 'status',
        dataIndex: 'status',
        width: 140,
        align: 'center',
        filters: [
          {
            text: 'Generated',
            value: 'GENERATED'
          },
          {
            text: 'Printed',
            value: 'PRINTED'
          }
        ],
        onFilter: (value, record) => (record.status === value),
        render: (_, { status }) => {
          // let color = denomination.length > 5 ? 'geekblue' : 'green'; 'volcano'
          let color = 'volcano'
          if (status.toUpperCase() === 'PRINTED') color = 'orange'
          if (status.toUpperCase() === 'SHIPPED') color = 'lime'
          if (status.toUpperCase() === 'DELIVERED') color = 'green'
          return (
            <Tag color={color}>
              {status.toUpperCase()}
            </Tag>
          )
        }
      },
      {
        title: 'Actions',
        key: 'action',
        width: 120,
        render: (_, record) => {
          let statusButton = null
          if (['SHIPPED','DELIVERED'].includes(record.status)) {
            statusButton = <ButtonPrimary small color="blue" icon={faTruckFast} openUrl={`https://www.fedex.com/fedextrack/?trknbr=${record.trackingNumber.replace(/ /, '')}`}>Track</ButtonPrimary>
          }
          let actionButton = null
          if (record.status === 'DELIVERED') {
            actionButton = <ButtonPrimary small color="navy" icon={faHandBackFist} onClick={() => setTransferClaim({ transferId: record.transferId, packageId: record.id })}>Claim</ButtonPrimary>
          }
          return (
            <div className={styles.actions}>
              {statusButton}
              {actionButton}
            </div>
          )
        }
      }
    ]

    const dataSource = data
      .map(itm => {
        let total = 0
        let totalPowers = 0
        if (itm?.details?.metadata?.powers) {
          Object.keys(itm.details.metadata.powers).forEach(value => {
            total += (+value * +itm.details.metadata.powers[value])
            totalPowers += +itm.details.metadata.powers[value]
          })
        }
        return {
          id: itm.fb_id,
          dbId: itm.id,
          name: itm.package_id,
          transferId: itm.transferId,
          status: itm.status,
          trackingNumber: itm.tracking_number,
          dateIssued: dayjs.utc(itm.date_issued).local().format(`MM/DD/YYYY`),
          dateVoid: dayjs.utc(itm.date_expires).local().format(`MM/DD/YYYY`),
          numbers: { firstNumber: itm.details.firstNumber || null, lastNumber: itm.details.lastNumber || null },
          total: '$' + numeral(total).format('0,0'),
          totalPowers,
          denominations: (itm?.details?.metadata?.powers) ? Object.keys(itm.details.metadata.powers) : [],
          details: itm?.details,
          action: []
        }
      })
      // .filter(itm => {
      //   if (search && search !== '') {
      //     return itm.agencyName.toLowerCase().includes(search.toLowerCase())
      //   }
      //   return true
      // })
    return (
      <Table
        bordered
        dataSource={dataSource}
        columns={columns}
        size="small"
        pagination={false}
      />
    )
  }

  return (
    <div className={styles.generatePowers}>
      {(transfers?.length > 0) && (
        <div className={styles.generatePowers__list}>
          <h5 className="rad">Incoming Transfers</h5>
          <div>
            {_getTable(transfers)}
          </div>
        </div>
      )}
      
      <div className={styles.generatePowers__list}>
        <h5 className="rad">Power Packs</h5>
        <div>
          {(packages?.length > 0) && _getTable(packages)}
          {(packages?.length === 0) && <p className={styles.noResults} style={{ color: '#FFF' }}>You have not entered any power packs.</p>}
        </div>
      </div>
      {transferClaim && <PowerPackTransfer agency={agency} transferId={transferClaim.transferId} packageId={transferClaim.packageId} setIsLoading={setIsLoading} setError={setError} onComplete={_fetchPackages} onClose={() => setTransferClaim(null)} />}
    </div>
  )
}

export default InventoryPowerPacks
